import React from 'react';
import { useNavigate } from 'react-router-dom';
import PracticeView from './PracticeView';

function PracticeApp({
  sessionId,
  fileName,
  practiceTopicName,
  questions,
  selectedQuestionId,
  onSelectQuestion,
  selectedQuestion,
  onFieldChange,
  onGradeCurrent,
  canGradeCurrent,
  onGrade,
  onGeneratePractice,
  onNextQuestion,
  practiceViewActive,
  practiceSessionId,
  practiceQuestions,
  status,
  hasGradableAnswers,
  selectedPracticeIndex,
  authEmail,
  authPassword,
}) {
  const navigate = useNavigate();

  // Determine which questions and session to display
  const activeQuestions = practiceViewActive ? practiceQuestions : questions;
  const activeSessionId = practiceViewActive ? practiceSessionId : sessionId;
  const activeTopicName = practiceViewActive
    ? (practiceTopicName || 'Practice')
    : (fileName || 'Primary Mathematics');

  if (!sessionId && !practiceSessionId) {
    return (
      <div className="browse-page-container">
        <div className="empty-practice-state">
          <h2>No practice session loaded</h2>
          <p>Browse topics and click one to start practicing.</p>
          <div className="empty-practice-actions">
            <button
              type="button"
              className="primary"
              onClick={() => navigate('/')}
            >
              Browse by State
            </button>
            <button
              type="button"
              className="ghost"
              onClick={() => navigate('/topics')}
            >
              Browse by Topic
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="workspace">
      <header className="workspace-header">
        <div className="workspace-header-left">
          <button
            type="button"
            className="back-button"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
          <div>
            <p className="eyebrow">Practice Your Math Skills</p>
            <h2>{activeTopicName}</h2>
          </div>
        </div>
        <div className="controls">
          <span className="hint">{authEmail || ''}</span>
        </div>
      </header>

      <PracticeView
        practiceQuestions={activeQuestions}
        selectedQuestionId={selectedQuestionId}
        onSelectQuestion={onSelectQuestion}
        selectedQuestion={selectedQuestion}
        onFieldChange={onFieldChange}
        onGradeCurrent={onGradeCurrent}
        canGradeCurrent={canGradeCurrent}
        onGrade={onGrade}
        onNextQuestion={onNextQuestion}
        onGeneratePractice={onGeneratePractice}
        status={status}
        practiceSessionId={activeSessionId}
        hasGradableAnswers={hasGradableAnswers}
        selectedIndex={selectedPracticeIndex}
        topicName={activeTopicName}
        showGeneratePractice={!practiceViewActive && Boolean(selectedQuestion)}
        authEmail={authEmail}
        authPassword={authPassword}
      />
    </div>
  );
}

export default PracticeApp;
